import React, { useEffect, useState } from "react";
import "./buttons.css";

const InstallPWA = () => {
  const [supportsPWA, setSupportsPWA] = useState(false);
  const [promptInstall, setPromptInstall] = useState(null);

  useEffect(() => {
    /// Handler for the `beforeinstallprompt` event
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      console.log("`beforeinstallprompt` triggered!");
      setSupportsPWA(true);
      setPromptInstall(e); // Save the event to use later
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt
      );
    };
  }, []);

  const handleInstallClick = async (evt) => {
    evt.preventDefault();

    if (!promptInstall) {
      console.warn("Install prompt is not available.");
      return;
    }

    // Show the install prompt
    promptInstall.prompt();

    // Wait for the user's choice
    const { outcome } = await promptInstall.userChoice;
    console.log(`User choice: ${outcome}`);

    // Clear the prompt to prevent reuse
    setPromptInstall(null);

    // Optionally, hide the install button
    if (outcome === "accepted") {
      console.log("PWA installation accepted!");
      setSupportsPWA(false);
    } else {
      console.log("PWA installation dismissed.");
    }
  };

  if (!supportsPWA) {
    // If PWA is already installed or prompt isn't supported, hide the button
    return null;
  }

  return (
    <div>
      <span onClick={handleInstallClick} className="installButton">
        App
      </span>
    </div>
  );
};

export default InstallPWA;
